import { render, staticRenderFns } from "./ModuleMedia.vue?vue&type=template&id=10f06bf8"
import script from "./ModuleMedia.vue?vue&type=script&lang=js"
export * from "./ModuleMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports